import styled from 'styled-components'

export default styled.div`
  border-bottom: 1px solid #eee;
  line-height: 20px;
  margin-left: 10px;
  position: relative;
  width: calc(100% - 150px);
`
